import {
  BarChart3, Settings, Building2, Globe, Map, LineChart,
  MessageSquare, BrainCircuit, Trophy, GitCompareArrows, PieChart
} from "lucide-react";

const NAV_TABS = [
  { id: "dashboard", icon: BarChart3, labelKey: "nav.dashboard" },
  { id: "decisions", icon: Settings, labelKey: "nav.decisions" },
  { id: "company", icon: Building2, labelKey: "nav.company" },
  { id: "market", icon: Globe, labelKey: "nav.market" },
  { id: "marketshare", icon: PieChart, labelKey: "nav.marketShare" },
  { id: "compare", icon: GitCompareArrows, labelKey: "nav.compare" },
  { id: "routemap", icon: Map, labelKey: "nav.routeMap" },
  { id: "history", icon: LineChart, labelKey: "nav.history" },
  { id: "team", icon: MessageSquare, labelKey: "nav.team" },
  { id: "ai", icon: BrainCircuit, labelKey: "nav.aiAdvisor" },
  { id: "achievements", icon: Trophy, labelKey: "nav.badges" },
];

export default NAV_TABS;
